import { FC } from 'react';

import { Button } from '@hh.ru/magritte-ui';
import { GearOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';
import useTrls from 'hooks/translation/useTrls';

import { SelectColumnsModal } from 'components/CampaignsDashboard/components/CampaignsFiltersPanel/components/SelectColumnsModal/SelectColumnsModal';

const TrlKeys = {
    button: 'CampaignsFiltersPanel.components.SelectColumnsButton.button',
};

export const SelectColumnsButton: FC = () => {
    const [isModalVisible, setIsModalVisibleOn, setIsModalVisibleOff] = useOnOffState(false);

    const trls = useTrls();

    return (
        <>
            <Button
                data-qa="campaigns-columns-button"
                mode="secondary"
                style="neutral"
                icon={<GearOutlinedSize24 />}
                onClick={setIsModalVisibleOn}
            >
                {trls(TrlKeys.button)}
            </Button>
            <SelectColumnsModal visible={isModalVisible} onClose={setIsModalVisibleOff} />
        </>
    );
};
